<template>
  <div>
    <HeroImage v-if="entry.image[0]" :image="entry.image[0]">
      <div class="container flex items-center h-full">
        <BarText tag="h1" :text="entry.textOverlay" class="flow-root fluid-4xl leading-none" />
      </div>
    </HeroImage>
    <ContentBlocks :entry="entry" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import HeroImage from '@/components/common/HeroImage';
import BarText from '@/components/BarText.vue';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';

export const ExpertOverviewPageFragment = gql`
  fragment ExpertOverviewPageFragment on expertOverview_Entry {
    title
    uri
    textOverlay
    seoTopics
    image {
      ...CraftAssetFragment
    }
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'ExpertOverviewPage',
  components: { BarText, HeroImage, ContentBlocks },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
  },
});
</script>
